<template>
  <v-select
    v-model="card"
    outlined
    :error-messages="error_messages"
    :loading="loading"
    :disabled="loading"
    label="Cartão"
    :items="getDebitCards"
    item-text="name"
    item-value="id"
    @change="setCard()"
  ></v-select>
</template>

<script>
import {
  mapGetters,
} from 'vuex'
import axios from '@/plugins/axios'

export default {

  components: {},
  props: {
    value: {},
    error_messages: {},
  },

  data: () => ({
    loading: false,
    card: '',
  }),

  watch: {
    value(val) {
      this.card = val
    },

  },

  created() {
    this.card = this.value
  },
  computed: {
    ...mapGetters('select', ['getDebitCards']),
  },

  methods: {
    setCard() {
      this.$emit('input', this.card)
      this.$emit('change', this.card)

      // proucura o objeto correspondente ao id card
      const object = this.getDebitCards.find(item => item.id == this.card)

      this.$emit('object', object)
    },

  },
}
</script>
